import React from "react";
import { getCommunicationAiParserDetails } from "../helpers/communication-ai-parser-helper";
import type { TCommunicationTask } from "../helpers/communication-types-helper";

interface ICommunicationAiParserFieldProps {
  task: TCommunicationTask;
}

const CommunicationAiParserField: React.FC<ICommunicationAiParserFieldProps> = ({ task }) => {
  const { aiParserLabel, selectedParserRunSummary } = getCommunicationAiParserDetails(task);
  const primaryLabel = aiParserLabel || "\u2014";

  return (
    <div className="communication-ai-parser-field">
      <span
        className="communication-ai-parser-field__primary"
        title={primaryLabel !== "\u2014" ? primaryLabel : undefined}
      >
        {primaryLabel}
      </span>
      {selectedParserRunSummary && (
        <span
          className="communication-ai-parser-field__secondary"
          title={selectedParserRunSummary}
        >
          {selectedParserRunSummary}
        </span>
      )}
    </div>
  );
};

export default CommunicationAiParserField;
